/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useEffect, useState } from "react";
import cn from "classnames";
import { CPTCheckBoxItem } from "./CPTCheckBoxItem";

export const CPTCheckbox = ({ data, globalShow, suggestions, showTitle = true }) => {
  const [show, setShow] = useState(false);
  const [hasCheckedItem, setHasCheckedItem] = useState(false);
  const showHideIcon = require("./../../assets/esign-ui-icons/ico-showhide.svg");

  useEffect(() => {
    setShow(globalShow);
  }, [globalShow]);

  useEffect(() => {
    shouldCheckItem();
  });

  function shouldCheckItem() {
    const checkedItems = data.esignStatements.some((item) => item.selected);
    if (checkedItems) {
      setHasCheckedItem(true);
    }
  }

  return (
    <div hidden={!(globalShow || hasCheckedItem)}>
      {showTitle && (
        <div
          className="grp-hdr"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {globalShow || hasCheckedItem ? <h3>{data.name}:</h3> : null}
          <button
            className="btn btn-sm btn-hide-section btn-hide-show"
            onClick={(e) => {
              e.preventDefault();
              setShow(!show);
            }}
          >
            <span style={{ color: "#555" }}>{show ? "Hide" : "Show"}</span>
            <img id="loading-spinner" src={showHideIcon} className={cn("showhide-ico", { show: !show })} />
          </button>
        </div>
      )}
      {data.esignStatements.map((item, index) => {
        return (
          <CPTCheckBoxItem
            key={`checkboxitem-${index}`}
            apiName={data.apiName}
            shouldShow={show}
            item={item}
            suggestions={suggestions}
          />
        );
      })}
    </div>
  );
};
